import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Equipment.Balance`]: 'Balance',
      [`${prefix}.TotalMaterial.TareMass`]: 'Tare Mass',
      [`${prefix}.TotalMaterial.WetSoilAndTareMass`]: 'Tare and Total Sample Mass',
      [`${prefix}.TotalMaterial.WetSoilMass`]: 'Total Sample Mass',
      [`${prefix}.NoOversizeMaterial`]: 'No oversize material',
      [`${prefix}.Sieves.Sieve`]: 'Sieve',
      [`${prefix}.Sieves.WetMassRetained`]: 'Cumulative Wet Mass Retained',
      [`${prefix}.Sieves.CumulativeWetMassRetainedPercent`]: 'Cumulative Wet Mass Retained',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Sieves.CumulativeWetMassRetainedPercent`]: '%',
    })
  );

export default getLabelConfig;
